import { FC } from 'react';

import { useGet } from '#/hooks';
import { InvoicesKeys } from '#/hooks/api/invoices/InvoicesKeys';
import { API } from '#/lib/network/API';
import { Invoice } from '#/models/invoice/Invoice';

import { Document } from '../../models';
import { AsyncComponent } from '../async/AsyncComponent';
import { RenderInvoiceDocuments } from './RenderInvoiceDocuments';

interface InvoiceDocumentModalContentProps {
  document: Document;
  linkedInvoiceId: string;
  close: () => void;
  onTabChange: (name: string) => void;
  onNextClick?: (id: string) => void;
  onPreviousClick?: (id: string) => void;
  hasNext?: boolean;
  hasPrevious?: boolean;
}

export const InvoiceDocumentModalContent: FC<InvoiceDocumentModalContentProps> = ({
  document,
  linkedInvoiceId,
  close,
  onTabChange,
  onNextClick,
  onPreviousClick,
  hasNext,
  hasPrevious
}) => {
  const apiResult = useGet<Invoice>(InvoicesKeys.fromInvoice(linkedInvoiceId), API.invoices.get(linkedInvoiceId));

  return (
    <>
      <AsyncComponent apiResult={apiResult}>
        {linkedInvoice => (
          <RenderInvoiceDocuments
            document={document}
            linkedInvoice={linkedInvoice}
            close={close}
            onTabChange={onTabChange}
            onNextClick={onNextClick}
            onPreviousClick={onPreviousClick}
            hasNext={hasNext}
            hasPrevious={hasPrevious}
          />
        )}
      </AsyncComponent>
    </>
  );
};
